// Single source of truth for the operating company's legal identity.
// Displayed in the footer ownership notice (and reusable on Terms / Contact /
// invoices) to satisfy Indian disclosure requirements:
//   • Companies Act 2013 §12(3)(c) — legal name, registered office, CIN, phone, email
//   • Consumer Protection (E-Commerce) Rules 2020 — legal name, address, Grievance Officer
//   • IT Intermediary Guidelines 2021 — Grievance Officer name + contact
//   • GST law — GSTIN on the platform
//
// Replace every "TODO" below with the registered values before shipping.
export const COMPANY = {
  brand: "The Spotters",
  legalName: "Divyantik India Private Limited",
  cin: "U15201DL2024PTC425019",
  gstin: "07AAKCD5545J1ZC",
  registeredOffice: "9th Floor, Block A-9, Pocket 1A, Flat 29, Sector A1-4, Narela, New Delhi – 110040",
  email: "support@thespotters.in",
  phone: "+91 93151 19957",
  grievanceOfficer: {
    name: "Kartik Gupta",                 // named person required by IT Rules 2021 / E-Commerce Rules 2020
    email: "support@thespotters.in",
    phone: "+91 95609 40469",
  },
  // Social handles — replace with your real profile URLs. A link is hidden in
  // the footer until its URL is filled in.
  social: {
    instagram: "https://www.instagram.com/thespotters.official",
    facebook: "https://www.facebook.com/share/1Bom15atBn/",
    youtube: "https://www.youtube.com/@thespotters.official",
    pinterest: "https://pin.it/1vbRAbxf0",
    x: "https://x.com/TheSpottersHQ",
  },
};

// True only once the mandatory identifiers are filled in — lets the footer hide
// half-blank legal lines until the real values are present.
export const companyLegalReady = () =>
  ![COMPANY.cin, COMPANY.gstin, COMPANY.registeredOffice].some((v) => String(v).startsWith("TODO"));
